<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 28 28">
        <g id="Group_2819" data-name="Group 2819" transform="translate(-312 -156)">
            <circle id="Ellipse_187" data-name="Ellipse 187" cx="14" cy="14" r="14" transform="translate(312 156)"
                    fill="#cedbff"/>
            <g id="Outline" transform="translate(296 148)">
                <path id="Path_69920" data-name="Path 69920"
                      d="M16.667,35.667a1,1,0,0,1,1-1h1v.667h-1a.333.333,0,0,0-.333.333v14a.333.333,0,0,0,.333.333H27a.333.333,0,0,0,.333-.333v-.833h-.667v.5H18V46.471l2.1,2.1a.333.333,0,0,0,.236.1h6.333V48h-6V45.667a.333.333,0,0,0-.333-.333H18V36h.667a.333.333,0,0,0,.333.333h6.667A.333.333,0,0,0,26,36h.667v1.333h.667V35.667A.333.333,0,0,0,27,35.333H26v-.667h1a1,1,0,0,1,1,1v2h.667v-2A1.669,1.669,0,0,0,27,34H25.471l-.569-.569a.333.333,0,0,0-.236-.1h-1a1.333,1.333,0,0,0-2.667,0H20a.333.333,0,0,0-.236.1L19.2,34H17.667A1.669,1.669,0,0,0,16,35.667V37h.667ZM20,47.529,18.471,46H20ZM20.138,34h1.2a.333.333,0,0,0,.333-.333v-.333a.667.667,0,1,1,1.333,0v.333a.333.333,0,0,0,.333.333h1.2l.8.8v.862h-6V34.8Z"
                      transform="translate(0 -15.333)" fill="#799cfb"/>
                <path id="Path_69921" data-name="Path 69921"
                      d="M28,180a1,1,0,0,1-1,1H17.667a1,1,0,0,1-1-1V168H16v12a1.669,1.669,0,0,0,1.667,1.667H27A1.669,1.669,0,0,0,28.667,180v-.667H28Z"
                      transform="translate(0 -145.667)" fill="#799cfb"/>
                <path id="Path_69933" data-name="Path 69933"
                      d="M234.331,16.333A.333.333,0,0,0,234,16h-.667a.667.667,0,1,0,0,1.333H234a.333.333,0,0,0,.333-.333.334.334,0,0,1,.333.333v5a2.667,2.667,0,1,1-5.333,0v-5a.334.334,0,0,1,.333-.333.333.333,0,0,0,.333.333h.667a.667.667,0,0,0,0-1.333H230a.333.333,0,0,0-.333.333,1,1,0,0,0-1,1v5a3.338,3.338,0,0,0,3,3.317V30.5A2.5,2.5,0,0,1,228,32.71V27.667h-.667V32.2a2.49,2.49,0,0,1-.667-1.7V27.309a2.333,2.333,0,1,0-.667,0V30.5a3.167,3.167,0,0,0,6.333,0V25.65a3.338,3.338,0,0,0,3-3.317v-5A1,1,0,0,0,234.331,16.333ZM226,25a.333.333,0,1,1,.333.333A.333.333,0,0,1,226,25Zm-1.333,0a1.667,1.667,0,1,1,2,1.633v-.691a1,1,0,1,0-.667,0v.691A1.669,1.669,0,0,1,224.665,25Z"
                      transform="translate(-199.331)" fill="#799cfb"/>
            </g>
        </g>
    </svg>

</template>

<script>
    export default {
        name: "IComplaint",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
